import React, { useState, useEffect, useCallback } from 'react';
import { Snackbar, Button, Alert } from '@mui/material';

/**
 * Listens for Service Worker updates (dispatched from index.js)
 * and shows a banner prompting the user to reload.
 */
export default function UpdateNotification() {
  const [waitingWorker, setWaitingWorker] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      setWaitingWorker(e.detail);
      setOpen(true);
    };
    window.addEventListener('swUpdate', handler);
    return () => window.removeEventListener('swUpdate', handler);
  }, []);

  const handleUpdate = useCallback(() => {
    if (waitingWorker?.waiting) {
      waitingWorker.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    setOpen(false);
    // Reload once the new SW takes over
    navigator.serviceWorker?.addEventListener('controllerchange', () => {
      window.location.reload();
    });
  }, [waitingWorker]);

  return (
    <Snackbar
      open={open}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        variant="filled"
        action={
          <Button color="inherit" size="small" onClick={handleUpdate}>
            Update now
          </Button>
        }
        sx={{ width: '100%' }}
      >
        A new version of Biztimize is available.
      </Alert>
    </Snackbar>
  );
}
